import type { AlternativeTextPredictionButtonFragment } from "../../client/generated";
import { useAuth } from "react-oidc-context";
import { predictAlternative } from "../../client/predictions";
import { useTranslation } from "react-i18next";
import { PredictionButton } from "../../predictions/PredictionButton";

type Props = {
  fragment: AlternativeTextPredictionButtonFragment;
  onAccept: (prediction: string) => void;
};

export function AlternativeTextPredictionButton({ fragment, onAccept }: Props) {
  const { t } = useTranslation();
  const auth = useAuth();

  const predict = async () => {
    if (!fragment.page.pngUrl || !auth.user) return;

    return await predictAlternative(
      fragment.page.pngUrl,
      auth.user.access_token,
      fragment.shape.aabb,
      fragment.document.metadata.language,
    );
  };

  return (
    <PredictionButton
      label={t("AlternativeTextPredictionButton.label")}
      onPredict={predict}
      onAccept={onAccept}
    />
  );
}
